import SuccessCard from 'components/shared/SuccessCard/SuccessCard'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import ProjectSuggestions from 'components/Project/ProjectSuggestions/ProjectSuggestions'

export const CompletedProject = ({ project }) => {
  const { t, i18n } = useTranslation()
  return (
    <>
      <HtmlHead
        title={`${project.title} | Complete`}
        image={project.heroImage}
      />
      <section className="c-project__content">
        <SuccessCard
          text={t('project.project_complete.congratulations', {
            title: project.title,
          })}
          subtext={t('project.project_complete.well_done')}
        ></SuccessCard>
        <ProjectSuggestions project={project}></ProjectSuggestions>
      </section>
    </>
  )
}

export default CompletedProject
CompletedProject.propTypes = {
  project: PropTypes.object.isRequired,
}
